import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { SlotComponent } from '../slot.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentsModule } from '../../../../../lib';
import { AsyncPipe } from '@angular/common';
import { SlotTooltipPipe, TranslationKeyPipe, DelayDisplayImpurePipe } from '../../../pipes';
import { VisualComponent } from '../../visual/visual.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ca-slot-dropdown',
    imports: [ComponentsModule, TranslateModule, AsyncPipe, TranslationKeyPipe, VisualComponent, DelayDisplayImpurePipe, SlotTooltipPipe],
    templateUrl: './slot-dropdown.component.html',
    styleUrl: './slot-dropdown.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotDropdownComponent),
            multi: true
        }
    ]
})
export class SlotDropdownComponent extends SlotComponent {
    ariaLabel = input<string>('');

    override writeValue(value: any): void {
        this.value.set(value);
    }

    onValueChange(value: any) {
        if (!this.isDisabled) {
            this.value.set(value);
            this.onChange(value);
        }
    }
}
